/* eslint-disable */
import GraphQL from '../../../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HistoricalWebsiteHealthChartQueryVariables = GraphQL.Exact<{
  endDate: GraphQL.Scalars['DateYMD']['input'];
  scope: GraphQL.Scalars['String']['input'];
  startDate: GraphQL.Scalars['DateYMD']['input'];
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type HistoricalWebsiteHealthChartQuery = { readonly __typename?: 'Query', readonly website: { readonly __typename?: 'Website', readonly id: CK.WebsiteId, readonly dashboardData: { readonly __typename?: 'WebsiteDashboardData', readonly healthChanges: { readonly __typename?: 'WebsiteDashboardHealthChanges', readonly id: CK.ID, readonly data: ReadonlyArray<{ readonly __typename?: 'WebsiteDashboardHealthChangesData', readonly date: CK.DateYMD, readonly health: number | null }> | null } } | null } | null };


export const HistoricalWebsiteHealthChartDocument = gql`
    query HistoricalWebsiteHealthChart($endDate: DateYMD!, $scope: String!, $startDate: DateYMD!, $websiteId: WebsiteId!) {
  website(id: $websiteId) {
    id
    dashboardData {
      healthChanges(endDate: $endDate, scope: $scope, startDate: $startDate) {
        data {
          date
          health
        }
        id
      }
    }
  }
}
    `;

/**
 * __useHistoricalWebsiteHealthChartQuery__
 *
 * To run a query within a React component, call `useHistoricalWebsiteHealthChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricalWebsiteHealthChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricalWebsiteHealthChartQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      scope: // value for 'scope'
 *      startDate: // value for 'startDate'
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useHistoricalWebsiteHealthChartQuery(baseOptions: Apollo.QueryHookOptions<HistoricalWebsiteHealthChartQuery, HistoricalWebsiteHealthChartQueryVariables> & ({ variables: HistoricalWebsiteHealthChartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HistoricalWebsiteHealthChartQuery, HistoricalWebsiteHealthChartQueryVariables>(HistoricalWebsiteHealthChartDocument, options);
      }
export function useHistoricalWebsiteHealthChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HistoricalWebsiteHealthChartQuery, HistoricalWebsiteHealthChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HistoricalWebsiteHealthChartQuery, HistoricalWebsiteHealthChartQueryVariables>(HistoricalWebsiteHealthChartDocument, options);
        }
export function useHistoricalWebsiteHealthChartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HistoricalWebsiteHealthChartQuery, HistoricalWebsiteHealthChartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HistoricalWebsiteHealthChartQuery, HistoricalWebsiteHealthChartQueryVariables>(HistoricalWebsiteHealthChartDocument, options);
        }
export type HistoricalWebsiteHealthChartQueryHookResult = ReturnType<typeof useHistoricalWebsiteHealthChartQuery>;
export type HistoricalWebsiteHealthChartLazyQueryHookResult = ReturnType<typeof useHistoricalWebsiteHealthChartLazyQuery>;
export type HistoricalWebsiteHealthChartSuspenseQueryHookResult = ReturnType<typeof useHistoricalWebsiteHealthChartSuspenseQuery>;
export type HistoricalWebsiteHealthChartQueryResult = Apollo.QueryResult<HistoricalWebsiteHealthChartQuery, HistoricalWebsiteHealthChartQueryVariables>;